import './style.scss';

const Logo = () => {
  return (
    <div className="logo">
      <img 
        src="/logo.png" 
        alt="Logo" 
        className="img-fluid" 
      />
    </div>
  );
};

export default Logo;